import React from 'react';
import BigHeader from '../../components/BigHeader';
import SideBar from '../../components/SideBar';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';

const Results = () => {

	const sections = [
		{
			sectionId: "overview",
			title: "General overview"
	},
			{
			sectionId: "cloning",
			title: "Cloning & purification"
	},
			{
			sectionId: "mucin",
			title: "Mucin binder assessment"
	},
			{
			sectionId: "tev",
			title: "TEV protease validation of BBa_K4602430"
	}
	,		{
			sectionId: "de-novo",
			title: "De novo protein assessment (T4 binders)"
	},
			{
			sectionId: "hpv",
			title: "De novo protein assessment (HPV binders)"
	}
	];
    return (
		<div class="page-body">
			<BigHeader headerText={'Results'} backgroundImage={'https://static.igem.wiki/teams/4602/wiki/images/images/background.jpg'}/>
			<Card>
			<p id="fdbd4f36-1a45-440c-80a7-b7ea6df340f0" class=""><strong>With the ultimate goal of building the foundations for 
			the development of a bio-manufacturable STI-preventing lubricant, a large part of our work was structured 
			outside of the lab, notably through developing strong theoretical models, reflecting on human practices, and 
			building a case for our endeavours as entrepreneurs. Our work extended in the lab, assessing binding and/or 
			anti-infectious properties of our designed proteins. In our assessment we have successfully discovered a few de novo 
			proteins which successfully demonstrate retention of phage in solution, solidifying our proof of concept.</strong> </p>
			</Card>
				<Container style={{marginLeft: '0px', marginTop: '8px', alignItems: 'stretch', marginRight:'0'}} >

			<Row>     
			<SideBar sections={sections}/> 
			<Col  style={{padding: '0', marginRight:'0'}}>

		
			<h1 id="overview" class="">General overview:</h1>
			<ul id="8de98b8f-51a1-4d77-b473-0b3e8464a3c9" class="bulleted-list">
				<li style={{listStyleType:"disc"}}>Potentially generated a protein successfully binding to T4 phage,
					retaining phage particles in solution and supporting our proof of concept</li>
			</ul>
			<ul id="20406fa4-df5a-47c1-ba61-0a93762ae69a" class="bulleted-list">
				<li style={{listStyleType:"disc"}}>Successfully designed and produced a strong driving plasmid <a
						href="http://parts.igem.org/Part:BBa_K4602420">BBa_K4602420</a>, easily generating proteins as a
					fusion with <a href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a>, allowing us to
					produce over 60 different strains of <em>E. coli (Rosetta BL21) </em>producing the following
					proteins.<ul id="ef56b92a-df7c-4db5-8d24-6f39a595df82" class="bulleted-list">
						<li style={{listStyleType:"circle"}}>3 candidate mucin-binding domains.<ul
								id="fe0eceb7-9c58-4494-a678-5407764d72d7" class="bulleted-list">
								<li style={{listStyleType:"square"}}>StcE_X409: <a
										href="http://parts.igem.org/Part:BBa_K4602002">BBa_K4602002</a></li>
							</ul>
							<ul id="5a3a40ca-e4d5-467b-9f01-ca6fcd00c643" class="bulleted-list">
								<li style={{listStyleType:"square"}}>hMUC2_CysD: <a
										href="http://parts.igem.org/Part:BBa_K4602003">BBa_K4602003</a></li>
							</ul>
							<ul id="85739316-e1cb-4a89-89cc-e4eb70b8b9f2" class="bulleted-list">
								<li style={{listStyleType:"square"}}>LEC_GREGR: <a
										href="http://parts.igem.org/Part:BBa_K4602004">BBa_K4602004</a></li>
							</ul>
						</li>
					</ul>
					<ul id="c79f4679-09e6-434d-bcf2-2c2dd344d074" class="bulleted-list">
						<li style={{listStyleType:"circle"}}>3 HPV16 major capsid protein variants (His-tagged,
							GFP-tagged, and wild type).<ul id="da08f1d2-5b3a-4570-b48a-3670e321e939"
								class="bulleted-list">
								<li style={{listStyleType:"square"}}><a
										href="http://parts.igem.org/Part:BBa_K4602001">BBa_K4602001</a></li>
							</ul>
						</li>
					</ul>
					<ul id="36701e9c-8361-4622-8337-3aa892397a1d" class="bulleted-list">
						<li style={{listStyleType:"circle"}}>25 de novo candidate proteins for binding to HPV16 major
							capsid protein.</li>
					</ul>
					<ul id="53599c59-642d-4dd6-8c05-852153cbe67a" class="bulleted-list">
						<li style={{listStyleType:"circle"}}>33 de novo candidate proteins for binding to T4
							bacteriophage.<ul id="b818ebf2-c3f4-4067-92f5-e264fd965e24" class="bulleted-list">
								<li style={{listStyleType:"square"}}>Find our full list of assessed de novo proteins in
									our <a
										href="https://static.igem.wiki/teams/4602/wiki/parisbettencourt2023-ggig-full-list.csv">supplementary
										materials CSV</a><mark class="highlight-red">.</mark></li>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
			<ul id="d2cf3e45-0081-4e11-808c-3033d73f107c" class="bulleted-list">
				<li style={{listStyleType:"disc"}}>Validated the function of our sfGFP + TEV-cleavable flexible linker
					part: <a href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a>.</li>
			</ul>
			<ul id="dab713a2-9f8b-4c09-95a2-3147a98b4b8b" class="bulleted-list">
				<li style={{listStyleType:"disc"}}>Performed multiple engineering cycles in an attempt to create
					assessment methods for the capabilities of the de novo peptides.</li>
			</ul>
			<ul id="d57a0544-1e8d-4bca-b284-4933c396f624" class="bulleted-list">
				<li style={{listStyleType:"disc"}}>Characterised the binding capabilities of the mucin-binding domains
				</li>
			</ul>
			<p id="232dbe29-9dcd-44d0-845e-71207d618c3f" class="">
			</p>
			<h1 id="cloning" class="">Cloning &amp; purification</h1>
			<p id="a83717f9-380c-4ae4-84ff-6cd0229d4f32" class=""><strong><strong><strong><strong><strong><strong>Aim
										-</strong></strong></strong></strong></strong></strong> To clone and purify 58
				RFdiffusion designed hypothetical binding proteins, 3 mucin binding proteins, and HPV16 major capsid
				protein.</p>
			<p id="d771e7cb-b42c-4533-b9f8-1ab40e028cc8" class="">
				<strong><strong><strong><strong><strong><strong>Method</strong></strong></strong></strong></strong></strong>
				- <em><em><em><em><em><em><em><em><em><em><em><em><em>E. coli (ssp. Rosetta
																	BL21</em></em></em></em></em></em></em></em></em></em></em></em></em>)
				was transformed with plasmids containing the target sequence. His-tagged proteins were purified via
				Ni-NTA affinity column purification and validated through SDS-PAGE.</p>
			<p id="90d9502b-ea73-4b61-a0d6-529dcfd37689" class="">
				<strong><strong><strong><strong><strong><strong>Result</strong></strong></strong></strong></strong></strong>
				- All of our target sequences were successfully cloned into
				<em><em><em><em><em><em><em><em><em><em><em><em><em>E.
																	coli.</em></em></em></em></em></em></em></em></em></em></em></em></em><strong><strong><strong>
						</strong></strong></strong>All proteins existing in nature were successfully purified. Almost
				all of our RFdiffusion designed proteins were successfully purified.</p>
			<figure id="cc2a98f6-57e6-43db-9eae-c0f8cfa156a4" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/sds-page/cloning-process.jpg"><img style={{width: "100%", height:"100%"}}  alt="clonging"
						src="https://static.igem.wiki/teams/4602/wiki/sds-page/cloning-process.jpg" /></a>
				<figcaption>Fig 1. Representative overview of cloning process. In <strong><strong><strong>A)
							</strong></strong></strong>the plasmid backbone was first amplified from pTE2900 provided by
					our mentor Amir Pandi. The short insert to generate the TEV-cleavable linker for the our plasmid <a
						href="http://parts.igem.org/Part:BBa_K4602420">BBa_K4602420</a> was amplified through PCA as
					seen in <strong><strong>B)</strong></strong>, which was then inserted into the backbone through
					Gibson assembly and validated via colony PCR after cloning into
					<em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em>E. coli (ssp.
																									TOP10)</em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em>
					as seen in <strong><strong><strong>C)</strong></strong></strong>. Protein sequences generated
					through RF diffusion which were too short (see our supp. materials CSV) to be ordered as fragments
					through IDT or twist were ordered as oligonucleotides and amplified together, as seen in the short
					sequences in <strong><strong><strong>D)</strong></strong></strong>.</figcaption>
			</figure>
			<figure id="bc4508ad-b832-4852-8cba-9e1d5395b833" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/sds-page/colony-pcr.jpg"><img style={{width: "100%", height:"100%"}}  alt="pcr"
						src="https://static.igem.wiki/teams/4602/wiki/sds-page/colony-pcr.jpg" /></a>
				<figcaption>Fig 2. Representative batch colony PCR results of
					<em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em>E. coli (ssp.
																									TOP10)</em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em>
					a cells transformed with our RFdiffusion designed proteins. Colonies transformed with plasmids
					correctly cloned with our target gene (without recircularisation) was assessed through colony PCR.
					Candidate colonies were miniprepped and plasmids were validated through sequencing, before
					retransformation into high protein producing <em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em>E.
																									coli (ssp. Rosetta
																									BL21).</em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em>
				</figcaption>
			</figure>
			<figure id="284a4f2d-3dbc-45ae-9352-7d60fd08728d" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/cloning-1.jpg"><img style={{width: "100%", height:"100%"}}  alt="cloning"
						src="https://static.igem.wiki/teams/4602/wiki/images/cloning-1.jpg" /></a></figure>
			<ul id="58caa27d-df57-4306-8bdb-60bb23ee5be9" class="bulleted-list">
				<li style={{listStyleType:"disc"}}>66 separate proteins were cloned into <a
						href="http://parts.igem.org/Part:BBa_K4602420">BBa_K4602420</a> through golden gate cloning,
					transformed into <em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em>E.
																									coli (ssp.
																									TOP10)</em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em>
					for plasmid purification, validated through sanger sequencing, re-transformed into
					<em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em><em>E. coli (ssp.
																									Rosetta
																									BL21)</em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em></em>
					and purified as a fusion protein with <a
						href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a>. The full list of our proteins
					can be viewed in <a
						href="https://static.igem.wiki/teams/4602/wiki/parisbettencourt2023-ggig-full-list.csv">our
						supplementary materials CSV</a><mark class="highlight-red">.</mark></li>
			</ul>
			<figure id="db6af7b2-e4f5-429f-ba68-64bd04034bbe" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/images/sds-page/sds-collage.jpg"><img style={{width: "100%", height:"100%"}}  alt="sds"
						src="https://static.igem.wiki/teams/4602/wiki/images/sds-page/sds-collage.jpg" /></a>
				<figcaption>Fig 3. Representative images of SDS-PAGE gels of purified proteins. All proteins (except
					sfGFP) have been purified as a fusion protein with part <a
						href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a> (29 kD). </figcaption>
			</figure>
			<p id="c93e8335-e68f-45d5-9bea-4b19ce59ae97" class="">Through SDS-PAGE analysis we validated that all of our
				characterised part proteins (<a href="http://parts.igem.org/Part:BBa_K4602001">BBa_K4602001</a> ~ <a
					href="http://parts.igem.org/Part:BBa_K4602004">BBa_K4602004</a>) were generated likely successfully,
				though we cannot comment on folding without more sophisticated analysis. Most of our RFdiffusion
				proteins were generated successfully, except for a few which either had extremely low concentration
				(e.g. 2_880) or barely generated at all (e.g. 2_289), however the rate of successful translation is
				promising. For some proteins (such as StcE_X409 and HPV16_L1), there is a significant band at the 27~29
				kD mark, likely as a result of a significant amount of sfGFP (or <a
					href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a>) in the fraction due to incomplete
				synthesis, this contributes to the total protein concentration and should be taken into considerations.
				To avoid this, one could design a second separate affinity purification tag (such as GST) on the
				C-terminal of the protein to perform double purification, ensuring only complete proteins are obtained.
				For exact amino acid length and details on individual proteins please refer to our <a
					href="https://static.igem.wiki/teams/4602/wiki/parisbettencourt2023-ggig-full-list.csv">supplementary
					materials CSV file</a>.</p>
			<h1 id="mucin" class="">Mucin binder assessment</h1>
			<p id="ca65898e-1328-4ad0-bc6b-41363f55593d" class=""><strong><strong><strong><strong><strong><strong>Aim
										-</strong></strong></strong></strong></strong></strong> To assess the binding of
				our 3 candidate mucin binders to commercially available porcine submaxillary mucin.</p>
			<p id="2475de68-72a6-44bb-a6c5-2c743f9b8293" class="">
				<strong><strong><strong><strong><strong><strong>Method</strong></strong></strong></strong></strong></strong>
				- Mucin was fixated on ELISA plates, before incubation with GFP-tagged binding protein, and measured for
				fluorescence.</p>
			<p id="c6b0ed4b-f1b8-4bac-9e10-44ed6a2900ef" class="">
				<strong><strong><strong><strong><strong><strong>Result</strong></strong></strong></strong></strong></strong>
				- 2 out of 3 mucin binders exhibit significant binding, the degree of which is reliant of the acidity of
				mucin during fixation and on the concentrations of both mucin and mucin binder. Higher concentrations of
				mucin do not necessarily equate to higher levels of binding.</p>
			<p id="53d129c8-1adb-4410-8e22-a70a375223c2" class="">
			</p>
			<p id="9a9c3749-d3a5-49a6-8c76-44c1638b4555" class="">Our candidate mucin binders: StcE_X409 (<a
					href="http://parts.igem.org/Part:BBa_K4602002">BBa_K4602002</a>), hMUC2_CysD (<a
					href="http://parts.igem.org/Part:BBa_K4602003">BBa_K4602003</a>), LEC_GREGR (<a
					href="http://parts.igem.org/Part:BBa_K4602004">BBa_K4602004</a>) were assessed for their respective
				abilities to bind to commercially available Porcine submaxillary mucin.</p>
			<figure id="59fc5194-8176-4ddd-90f0-35d93af98e5c" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/wiki-general/wetlab/results/mucin-elisa-1-final-cropped.png"><img style={{width: "100%", height:"100%"}}  alt="cropped"
						src="https://static.igem.wiki/teams/4602/wiki/wiki-general/wetlab/results/mucin-elisa-1-final-cropped.png" /></a>
				<figcaption>Fig 4. LEC_GREGR exhibits the highest level of mucin binding, followed by StcE_X409. Binding
					of the sfGFP-fusion proteins to porcine submaxillary mucin (PSM) was measured as fluorescence
					intensity after PseudoELISA. Briefly, ELISA plates are coated with different concentrations of mucin
					in either acidic conditions (3.8 pH) or neutral solution, before being washed, blocked with 1% BSA,
					washed again, and incubated with around 1 mg/ml of sample protein. Negative controls are wells which
					are blocked with 1% BSA dissolved in either in 50% glycerol or normal PBS, without the addition of
					mucin. Positive control wells also do not contain mucin, but are not blocked with BSA, and represent
					the proteins binding to the ELISA plate itself.</figcaption>
			</figure>
			<p id="f1f87866-f556-4b45-9fd1-a7ef073e60dd" class="">Primary PseudoELISA results suggests that the
				LEC_GREGR exhibits the highest levels of binding. This lectin binds to the glycosidic side chains of
				mucin molecules, and thus it likely has far more available sites for binding. StcE_X409 showed high
				fluorescence compared to the GFP control as well, however this mucinase binding domain recognises PTS
				tandem repeats on the protein domains, and thus has far less available sites compared to LEC_GREGR. The
				CysD domain of human MUC2 showed lower fluorescence intensity than the GFP control, this domain is
				partially responsible for the inter-molecular interaction between mucin monomers and we believed may be
				a good candidate in binding, however we hypothesise that either A) the CysD region on its own is
				ineffective, perhaps due to lacking glycosidic side chains in <em><em><em><em><em><em><em>E.
											coli</em></em></em></em></em></em></em> expression, or B) the CysD domain is
				unable to interact with commercially available mucin, which has been highly denatured during the
				collection and purification from porcine stomachs.</p>
			<p id="bc022fa3-c690-40b9-a5fb-6e04e30ff054" class="">We also see that the concentration and pH at which the
				mucin is dissolved and coated on ELISA plates highly affects the level of binding for both LEC_GREGR and
				StcE_X409. Surprisingly, the higher concentrations do not necessarily facilitate a stronger signal,
				where acidic mucin at 0.5 mg/ml showed the highest signal for both samples. While we cannot say with
				these results whether this is more relevant for the mucin coating process or for the protein binding, it
				suggests that at least the mucin retains its binding acceptance at vaginal pH (which can be as low as
				3.8). We must further investigate the protein properties at acidic pH in the future.</p>
			<p id="5faa7f41-0df3-4eb6-bf1c-8c5aed878a9d" class="">
			</p>
			<figure id="9d5f2802-5ae3-430b-9196-0b4a2ecef514" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/wiki-general/wetlab/results/mucinelisa-full.png"><img style={{width: "100%", height:"100%"}}  alt="muci"
						src="https://static.igem.wiki/teams/4602/wiki/wiki-general/wetlab/results/mucinelisa-full.png" /></a>
				<figcaption>Fig 5. Mucin binding of LEC_GREGR and StcE_X409 are not directly correlated to Mucin
					concentration. PseudoELISA was conducted with both binding proteins and PSM at a range of
					concentrations. Mucin coating for the subplots in the top row was conducted at acidic pH (3.8) while
					those of the bottom row were coated at neutral pH. Negative controls are wells which are blocked
					with 1% BSA dissolved in either in 50% glycerol or normal PBS, without the addition of mucin.
					Positive control wells also do not contain mucin, but are not blocked with BSA, and represent the
					proteins binding to the ELISA plate itself.</figcaption>
			</figure>
			<p id="26a25565-c9e6-4c36-ac79-9735b174f06b" class="">Further concentration-response analysis confirms prior
				findings that higher concentrations of mucin do not necessarily facilitate more binding, in which mucin
				concentrations of 0.01 to 0.1 mg/ml facilitate a higher signal, this is interesting in the context of
				what may be the optimum mucin concentrations in the final lubricant product, however we cannot directly
				assume this due to the 2D fixation of mucin in this assay. Interestingly, while the acidic mucin once
				again showed highest acceptance at higher mucin concentrations and lower binder concentrations of around
				0.1 mg/ml, the highest signal was observed at 0.01 mg/ml mucin coat at neutral pH, against the highest
				concentration (1 mg/ml) of LEC_GREGR.</p>
			<h1 id="tev" class="">TEV protease validation of <a
					href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a></h1>
			<p id="9a4a093c-18ac-4298-96a0-113216622731" class=""><strong><strong><strong><strong><strong><strong>Aim
										-</strong></strong></strong></strong></strong></strong> To validate the correct
				synthesis and availability of the TEV protease restriction site, in the TEV-cleavable flexible linker of
				our part <a href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a>.</p>
			<p id="a419df58-53cb-42cb-ba19-1a2a81975e79" class="">
				<strong><strong><strong><strong><strong><strong>Method</strong></strong></strong></strong></strong></strong>
				- Purified fusion proteins were incubated with TEV protease and analysed through SDS-PAGE.</p>
			<p id="10c67871-d880-424f-a239-31cfed04a77d" class="">
				<strong><strong><strong><strong><strong><strong>Result</strong></strong></strong></strong></strong></strong>
				- All protein constructs were correctly cleaved, validating the part function in a range of fusion
				products.</p>
			<figure id="c89e4536-2208-4e1a-bb3c-3d523d2fc871" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/sds-page/sds-page/tev-removal-combined.png"><img style={{width: "100%", height:"100%"}}  alt="removal"
						src="https://static.igem.wiki/teams/4602/wiki/sds-page/sds-page/tev-removal-combined.png" /></a>
				<figcaption>Fig 6. <a href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a> is successfully
					cleaved by TEV protease when fused with proteins of various size and function. Candidate proteins
					fused with part <a href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a> were incubated
					TEV protease at 30°C for 1 hr with shaking and analysed through SDS-PAGE. All fractions appear to be
					cleaved properly, with a strong band formation at the 27 kD mark representing the cleaved sfGFP,
					which is also the same size as TEV protease itself, as seen in the rightmost column before the
					ladder (TEV protease alone as a negative control).</figcaption>
			</figure>
			<p id="535f9869-83c4-4ae8-9a04-27f36194a6a6" class="">The activity of <a
					href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a> as a TEV-cleavable linker was
				validated through, you guessed it, TEV protease cleavage, followed by SDS-PAGE analysis. Of the 5
				protein constructs we tested with TEV, all samples showed at least some bands at the expected size,
				validating the availability of the TEV recognition sequence of <a
					href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a> in a range of construct
				characteristics.</p>
			<p id="31317c54-ba85-4fa5-bff7-36021421d7f3" class="">While the TEV-cleavable linker was partially chosen as
				a placeholder for us before we do a thorough analysis of flexible linkers based on chosen binding
				proteins, combined with the effect of folding on protein fusion targets (or lack thereof, predicted
				through AlphaFold 2.0, see <a href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a> for more
				details) the part has a high level of utility and validates our use of it in our other experiments.</p>
			<h1 id="de-novo" class="">De novo protein assessment (T4 binders)</h1>
			<p id="50c7f8cc-3e58-45ca-8896-aa2fb59208a4" class=""><strong><strong><strong><strong><strong><strong>Aim
										-</strong></strong></strong></strong></strong></strong> To assess the ability of
				our hypothetical T4 bacteriophage binding proteins to retain phage proteins in solution, reducing the
				level of infection.</p>
			<p id="3f9f20f3-b2ab-454a-991c-e22554ec57d8" class="">
				<strong><strong><strong><strong><strong><strong>Method</strong></strong></strong></strong></strong></strong>
				- Multiple iterations of the engineering cycle were conducted to devise an adequate method of preventing
				phage infection (see engineering). Ultimately best results were achieved through pull-down phage
				retention assay (see protocols).</p>
			<p id="0b11b9a2-c5f9-4470-a4ef-7594542e5070" class="">
				<strong><strong><strong><strong><strong><strong>Result</strong></strong></strong></strong></strong></strong>
				- While most proteins show no significant difference compared to our controls, we identified 3 protein
				structures which exhibit visible retention of phage in solution.</p>
			<p id="0803ce3b-9794-4897-a011-e8bd4629d2fa" class="">
			</p>
			<p id="01bbd319-cf88-44d9-aa0f-15e188734944" class="">In order to assess the ability of our designed
				proteins to bind to T4 phage and prevent cell entry (into <em><em><em><em><em><em><em><em>E.
												coli</em></em></em></em></em></em></em></em>), we first attempted to
				capture the phages in solution using our PseudoELISA method, in which we immobilised the binding
				proteins on ELISA plates and incubated phage solution with them, before titering the phages in a plaque
				assay. We observed no differences between the control and test samples, and we hypothesised that the 2D
				matrix of binding protein would not be enough to significantly retain phages in the solution in a
				quantifiable manner.</p>
			<p id="bfeea6bd-f67d-4127-a311-4f65f14589e2" class="">Next we devised the phage retention pull down assay
				(see protocols), in which we have a much higher contact ratio of protein to phage.This experiments allows 
				us to extrapolate quantitative data about 3 different conditions. First, the flow through solution contains 
				the quantity of phages that are not retained. Second, the wash solution contains the remaining unbound 
				phage and those that bind weakly. And lastly, the elute solution contains the infective fraction of phages 
				that were successfully retained in the column and released by imidazole.</p>
			<figure id="b48d046e-51bd-4140-adf9-9b9d0e05555a" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/plaque-assays/t4-binders-all-samples-edited.png"><img style={{width: "100%", height:"100%"}}  alt="binders"
						src="https://static.igem.wiki/teams/4602/wiki/plaque-assays/t4-binders-all-samples-edited.png" /></a>
				<figcaption>Fig 8. No significant phage retention is observed by our candidate proteins, when incubated
					with phage at a molecular ratio of protein to T4 phage of around 100 : 1. Plaque assays were
					conducted after incubation of phage particles with our hypothetical proteins fused to BBa_K4602430,
					before Ni-NTA affinity purification pull-down. Each column represents serial dilutions of
					<strong><strong><strong>F) </strong></strong></strong>Primary flow-through,
					<strong><strong>W)</strong></strong> neutral buffer wash, and <strong><strong>E)</strong></strong>
					final elution of phage solutions after pull-down through affinity column post incubation with
					different binding proteins, <strong><strong><strong>S) </strong></strong></strong>represents
					original phage stock solution without pull-down for visual reference. The retention of phage
					particles is measured as the formation of visible plaques. <strong><strong><strong>Control
								1</strong></strong></strong> represents phage solution incubated and pulled down on
					their own, while <strong><strong><strong>Control 2</strong></strong></strong> represents phage
					solution pulled down the columns without the presence of Ni-NTA affinity agarose, to assess
					potential interactions between phages and the affinity gel. Analysis is mainly conducted through
					comparison of sample lanes against and
					<strong><strong><strong><strong><strong>sfGFP</strong></strong></strong></strong></strong> control.
				</figcaption>
			</figure>
			<p id="296803d1-7087-4b85-8532-ee553ba1b0ab" class="">Once again, we do not see a significant difference
				between any of the test samples and the controls. However, we noticed that there were a few test samples
				(46, 53, and 62) which showed very slightly fainter plaques formed by the first flowthrough compared to
				the controls. We wished to test these samples further but hypothesised that perhaps the concentration
				ratio of protein to phage was not high enough, so increased the protein concentration by a factor of 2
				and decreased phage concentration by a factor of 100 and repeated the experiment for these samples.</p>
			<figure id="1f4dde5c-09d2-471a-bc01-37570ac10cc8" class="image"><a
					href="https://static.igem.wiki/teams/4602/wiki/plaque-assays/t4-binders-elute-plaques-edited.png"><img style={{width: "100%", height:"100%"}}  alt="edited"
						src="https://static.igem.wiki/teams/4602/wiki/plaque-assays/t4-binders-elute-plaques-edited.png" /></a>
				<figcaption>Fig 9. Candidate proteins 62, 53, and 46 successfully retain phage particles in solution.
					Hypothetical T4 binding proteins in fusion with BBa_K4602430 were incubated with T4 phage at a
					molecular ratio of around 20,000 : 1 protein to phage, before Ni-NTA affinity column pull-down.
					Final elute was titered in a plaque assay. A visible increase in plaques is observed in all test
					samples compared to controls.</figcaption>
			</figure>
			<p id="f96dd4d7-878e-4212-a8f3-94f9dc936a81" class="">In the repeat we did not observe a significant change
				between the first flowthroughs of the test and control samples, however there was a much clearer
				difference between the plaque formations of the elutes, in which elutes from all three of the test
				samples showed much higher formations of plaques compared to the controls, suggesting that phage
				particles were indeed being retained by protein binding. This was consistent upon repeating the plaque 
				assays, we have a binding protein that successfully captures T4 bateriophage! While this change is not 
				as significant as we had hoped (not in the orders of magnitude), we are extremely excited for this finding 
				and wish tofurther explore these proteins.</p>
			<p id="01b1b55e-76b5-4b65-898d-02defccc91f3" class="">Unfortunately we did not have the time to conduct
				further experiments before the completion of this wiki, but we have further kinetics assessment through
				Microscale thermophoresis (MST) in planning.</p>
			<h1 id="hpv" class="">De novo protein assessment (HPV binders)</h1>
			<p id="4af83c94-d39e-4a7e-8fb8-e4c38eccbcdc" class=""><strong><strong><strong><strong><strong><strong>Aim
										-</strong></strong></strong></strong></strong></strong> To assess the ability of
				our RFdiffusion designed hypothetical HPV binding proteins to bind to HPV_L1 major capsid protein.</p>
			<p id="3bf85c35-9532-487a-b3b1-eb1d9e655739" class="">
				<strong><strong><strong><strong><strong><strong>Method</strong></strong></strong></strong></strong></strong>
				- We attempted PseudoELISA between the binding proteins and purified HPV L1 major capsid protein, and
				cell-lysate pull-down assays between the binding proteins and HPV L1 major capsid protein.</p>
			<p id="7c95dc33-f265-4821-a659-0195caa95046" class="">
				<strong><strong><strong><strong><strong><strong>Result</strong></strong></strong></strong></strong></strong>
				- Unfortunately due to experimental error and extenuating circumstances, we were unable to obtain valid
				data for our experiments. The folding interactions between <a
					href="http://parts.igem.org/Part:BBa_K4602430">BBa_K4602430</a> and <a
					href="http://parts.igem.org/Part:BBa_K4602001">BBa_K4602001</a> likely negatively affected the
				structure of HPV16_L1, while the buffer solutions for the cell lysate pull-down assay were not optimised
				at the time. We are still troubleshooting this process and will conduct repeats shortly.</p>
			<p id="6657ee9c-01de-49e3-903a-f7985d950af1" class="">
			</p>
			</Col>

			</Row>

			</Container>

		</div>
    )
}
export default Results;
